export default "__VITE_ASSET__t4gTYR8r__"